/* ============================================================
   MARKED v3 – Scroll-Reveal (window.MarkedV3)
   Beobachtet [data-mv3-reveal] und setzt den Wert auf "in".
   Reihenfolge-unabhängig: neue Sections melden sich über
   window.MarkedV3.scan() oder werden beim DOM-Ready gefunden.
   Ohne IntersectionObserver / bei reduzierter Bewegung wird
   sofort sichtbar geschaltet (kein Inhalt bleibt versteckt).
   ============================================================ */
(function () {
  if (window.MarkedV3) { window.MarkedV3.scan(); return; }

  var io = null;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll(els) {
    for (var i = 0; i < els.length; i++) els[i].setAttribute('data-mv3-reveal', 'in');
  }

  function scan() {
    var els = document.querySelectorAll('[data-mv3-reveal="1"]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { showAll(els); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.setAttribute('data-mv3-reveal', 'in');
            io.unobserve(en.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    for (var i = 0; i < els.length; i++) io.observe(els[i]);
  }

  window.MarkedV3 = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // Theme-Editor: nach jedem Section-Re-Render erneut einsammeln.
  document.addEventListener('shopify:section:load', scan);
})();
